export const ADD_ITEMS = 'ADD_ITEMS';

const GET_ITEMS_QUERY = `
query GetnAdsById($sitecode: String!, $host: String!, $clientId: String!, $lang: String!, $ids: [String], $userId: String!) {
  nAdsDetailById(sitecode: $sitecode, host: $host, clientId: $clientId, lang: $lang, ids: $ids, userId: $userId) {
    compactAds{
      compactPriceData {
        basePrice
        finalPrice
        isDiscountAvailable
        discountPercentage
        emiPlan {
          value
          frequency
        }
      }
      reserveData{
        status
        isReservedByCurrentUser
        expiryDate
        hasReservedAnyCar
      }
      compactAdData {
        data {
          id
          hasPhoneParam
          title
          sellerId
          categoryId
          imageData {
            id,
            external_id,
            height,
            width,
            url
          }
          imageUrl
          status {
            status
          }
          inspectionInfo{
            consent
            group
            inspectionId
            carId
          }
          parameters {
            key
            keyName
            value
            valueName
            formattedValue
          }
          price {
            key
            keyName
            value{
              currency{
                  iso4217,
                  locale,
                  post,
                  pre
                },
              display,
              raw
            }
          }
        }
      }
    }
    failedAds
  }
}
`;

const addItems = (itemsIds, config, userId) => (dispatch, _, { post }) => {
    const graphqlApiConfig = config.get('graphqlApi');

    const URL = '/api/adp/graphql';
    const headers = {
        'Content-Type': 'application/json'
    };

    const defaultVariables = {
        sitecode: graphqlApiConfig?.sitecode,
        host: graphqlApiConfig?.host,
        lang: graphqlApiConfig?.lang,
        clientId: graphqlApiConfig?.clientId,
        ids: itemsIds || [],
        userId
    };

    const params = {
        query: GET_ITEMS_QUERY,
        variables: defaultVariables
    };

    return dispatch(post(URL, ADD_ITEMS, params, headers));
};

const setBatchIndex = data => {
    return {
        type: 'MY_ZONE_SET_BATCH_INDEX',
        data
    };
};

const setMyZoneQuickFilters = data => {
    return {
        type: 'MY_ZONE_SET_QUICK_FILTERS',
        data
    };
};

export { setBatchIndex, addItems, setMyZoneQuickFilters };
